export default "__VITE_ASSET__7c76d802__"